interface Props {
    isShow: boolean;
}

export default function PolicyInformationClassificationAndEligibility({ isShow }: Props) {

    if (!isShow) {
        return null;
    }

    return (
        <div>
            <div className="overflow-x-auto rounded border border-gray-200">
                <table className="w-full min-w-[600px] border-collapse text-xs">
                    <thead>
                        <tr className="bg-[#eef6fc]">
                            <th className="w-1/2 border-b border-r border-[#c7e0f3] px-3 py-2 text-left font-semibold text-[#186cb2] sm:px-4 sm:py-2.5">
                                Classification of Individuals
                            </th>
                            <th className="w-1/2 border-b border-[#c7e0f3] px-3 py-2 text-left font-semibold text-[#186cb2] sm:px-4 sm:py-2.5">
                                Eligibility Date
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border-b border-r border-gray-200 px-3 py-2 text-gray-600 sm:px-4">
                                Insured Debtors as of the Effective
                                Date of this Policy.
                            </td>
                            <td className="border-b border-gray-200 px-3 py-2 text-gray-600 sm:px-4">
                                The Effective Date
                            </td>
                        </tr>
                        <tr>
                            <td className="border-r border-gray-200 px-3 py-2 text-gray-600 sm:px-4">
                                Individual who becomes an Insured
                                Debtor of the Creditor after the
                                Effective Date of this Policy.
                            </td>
                            <td className="border-b border-gray-200 px-3 py-2 text-gray-600 sm:px-4">
                                On the Date of Loan Disbursement to the
                                Individual by the Policyholder.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}